module.exports = __webpack_public_path__ + "img/bg.fe617d92.png";